"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.teamCreatedSubscription = exports.fetchTeamsQuery = exports.fetchTeamQuery = exports.updateTeamMutation = exports.deleteTeamMutation = exports.createTeamMutation = exports.teamFragment = void 0;
const tslib_1 = require("tslib");
const Team_graphql_1 = tslib_1.__importDefault(require("./fragments/Team.graphql"));
exports.teamFragment = Team_graphql_1.default;
const createTeam_graphql_1 = tslib_1.__importDefault(require("./mutations/createTeam.graphql"));
exports.createTeamMutation = createTeam_graphql_1.default;
const deleteTeam_graphql_1 = tslib_1.__importDefault(require("./mutations/deleteTeam.graphql"));
exports.deleteTeamMutation = deleteTeam_graphql_1.default;
const updateTeam_graphql_1 = tslib_1.__importDefault(require("./mutations/updateTeam.graphql"));
exports.updateTeamMutation = updateTeam_graphql_1.default;
const fetchTeam_graphql_1 = tslib_1.__importDefault(require("./queries/fetchTeam.graphql"));
exports.fetchTeamQuery = fetchTeam_graphql_1.default;
const fetchTeams_graphql_1 = tslib_1.__importDefault(require("./queries/fetchTeams.graphql"));
exports.fetchTeamsQuery = fetchTeams_graphql_1.default;
const teamCreated_graphql_1 = tslib_1.__importDefault(require("./subscriptions/teamCreated.graphql"));
exports.teamCreatedSubscription = teamCreated_graphql_1.default;
//# sourceMappingURL=index.js.map